export const divisionSettingsStyles = {
  container: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "flex-start",
    gap: "32px"
  },
  
  mainBox: {
    display: 'flex',
    width: '100%'
  },
  
  tabs: {
    borderRight: '1px solid #e0e0e0',
    width: 230,
    '& .MuiTabs-indicator': {
      right: 0,
      width: 3,
    }
  },
  
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 1
  },
  
  tabIcon: {
    color: '#1976d2'
  },
  
  tab: {
    minWidth: 'auto',
    padding: '8px 16px',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1976d2',
    '&.Mui-selected': {
      backgroundColor: 'white',
      color: '#333333',
    },
  },
  
  contentBox: {
    flex: 1,
    pl: 3
  },
  
  contentContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 200px)',
    overflow: 'hidden'
  },
  
  milestonesContainer: {
    width: '100%',
    height: 'calc(100vh - 300px)',
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarWidth: 'thin',
    scrollbarColor: '#c1c1c1 #f1f1f1',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '4px',
      '&:hover': {
        background: '#a8a8a8',
      },
    },
  }
} as const;

export const theme = {
  typography: {
    fontFamily: "karla, sans-serif",
    fontSize: 14,
  },
} as const; 